"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "frassinoro": {
    "a105f2e3": [{
      "hkey": "7d6d9a5c",
      "slug": "riccovolto",
      "name": "Riccovolto",
      "primary": true,
      "skipSearch": false
    }],
    "riccovolto-nuovo": [{
      "hkey": "7d6d9a5c",
      "slug": "riccovolto",
      "name": "Riccovolto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "265ed13b": [{
      "hkey": "93d5e0e9",
      "slug": "frassinoro",
      "name": "Frassinoro",
      "primary": true,
      "skipSearch": false
    }],
    "caldie": [{
      "hkey": "93d5e0e9",
      "slug": "frassinoro",
      "name": "Frassinoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13da6185": [{
      "hkey": "93d5e0e9",
      "slug": "frassinoro",
      "name": "Frassinoro",
      "primary": true,
      "skipSearch": false
    }],
    "casoni-di-fontanaluccia": [{
      "hkey": "93d5e0e9",
      "slug": "frassinoro",
      "name": "Frassinoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d19585a": [{
      "hkey": "7d6d9a5c",
      "slug": "riccovolto",
      "name": "Riccovolto",
      "primary": true,
      "skipSearch": false
    }],
    "riccavolto-nuovo": [{
      "hkey": "7d6d9a5c",
      "slug": "riccovolto",
      "name": "Riccovolto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;